import { createFileRoute } from '@tanstack/react-router'
import { requirePermission } from '../../../app/guards'
import { HrDashboardPage } from '../../../features/hr/dashboard-page'

export const Route = createFileRoute('/_app/hr/')({
  staticData: { crumb: 'hr' },
  beforeLoad: ({ context }) => requirePermission(context.session, 'employees.read'),
  component: HrDashboardPage,
})
